export type ThemeMode = 'dark' | 'light';

export type RoundedMode = 'sharp' | 'rounded';

export const THEME_STORAGE_KEY = 'contentgen-theme';
export const DEFAULT_THEME: ThemeMode = 'dark';

export const ROUNDED_STORAGE_KEY = 'contentgen-rounded';
export const DEFAULT_ROUNDED: RoundedMode = 'sharp';

export const isThemeMode = (value: unknown): value is ThemeMode =>
  value === 'dark' || value === 'light';

export const isRoundedMode = (value: unknown): value is RoundedMode =>
  value === 'sharp' || value === 'rounded';

export const getDocumentTheme = (): ThemeMode => {
  if (typeof document === 'undefined') return DEFAULT_THEME;
  const datasetTheme = document.documentElement.getAttribute('data-theme');
  return isThemeMode(datasetTheme) ? datasetTheme : DEFAULT_THEME;
};

export const getDocumentRounded = (): RoundedMode => {
  if (typeof document === 'undefined') return DEFAULT_ROUNDED;
  const attr = document.documentElement.getAttribute('data-rounded') as RoundedMode;
  return isRoundedMode(attr) ? attr : DEFAULT_ROUNDED;
};

export const applyTheme = (theme: ThemeMode) => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
  document.documentElement.style.colorScheme = theme;
};

export const applyRounded = (mode: RoundedMode) => {
  if (typeof document === 'undefined') return;
  if (mode === 'rounded') {
    document.documentElement.setAttribute('data-rounded', 'rounded');
  } else {
    document.documentElement.removeAttribute('data-rounded');
  }
};
